import { TFunction } from 'i18next'
import { FieldType, IFormConfig } from 'types'
import {
  ChargebackContact,
  chargebackContactSchema
} from './chargeback-contact-schema'
import { PhoneNumberField } from 'components/PhoneNumberField'
import { FullNameFields } from 'components/FullNameFields'
import { CountryAlpha2 } from 'generated/graphql'

export const getChargebackContactModalConfig = (
  t: TFunction
): IFormConfig<ChargebackContact> => ({
  schema: chargebackContactSchema,
  fields: [
    {
      name: 'individual.firstName',
      type: FieldType.CUSTOM,
      label: t('individuals.chargebackContact.fields.firstName.label'),
      tooltip: t('individuals.chargebackContact.fields.firstName.tooltip'),
      CustomComponent: FullNameFields,
      customComponentProps: {
        fields: [
          {
            name: 'individual.firstName',
            label: t('individuals.chargebackContact.fields.firstName.label'),
            placeholder: t(
              'individuals.chargebackContact.fields.firstName.placeholder'
            )
          },
          {
            name: 'individual.middleName',
            label: t('individuals.chargebackContact.fields.middleName.label'),
            placeholder: t(
              'individuals.chargebackContact.fields.middleName.placeholder'
            )
          },
          {
            name: 'individual.lastName',
            label: t('individuals.chargebackContact.fields.lastName.label'),
            placeholder: t(
              'individuals.chargebackContact.fields.lastName.placeholder'
            )
          }
        ]
      }
    },
    {
      name: 'relation.title',
      label: t('individuals.chargebackContact.fields.title.label'),
      placeholder: t('individuals.chargebackContact.fields.title.placeholder'),
      tooltip: t('individuals.chargebackContact.fields.title.tooltip')
    },
    {
      name: 'individual.email',
      label: t('individuals.chargebackContact.fields.email.label'),
      placeholder: t('individuals.chargebackContact.fields.email.placeholder'),
      tooltip: t('individuals.chargebackContact.fields.email.tooltip')
    },
    {
      name: 'individual.phoneNumber',
      type: FieldType.CUSTOM,
      label: t('individuals.chargebackContact.fields.phoneNumber.label'),
      tooltip: t('individuals.chargebackContact.fields.phoneNumber.tooltip'),
      CustomComponent: PhoneNumberField
    }
  ]
})
